<template>
    <div class="date-group">
        <div class="date-header" @click="expandOrdersOnDate">
            <b-icon :icon="isExpanded ? 'folder-open' : 'folder'" class="folder-icon"></b-icon>
            <span class="date-text">
                {{ date }}
                <span class="completion-status">
                    (<b-icon
                        :icon="orderIcon"
                        :style="{ color: orderColor }"
                        class="completion-icon"
                    ></b-icon>{{ completionText }})
                </span>
            </span>
        </div>

        <transition name="expand">
            <div v-show="isExpanded" class="orders-container">
                <OrderInList
                    v-for="order in orders"
                    :key="order.orderId"
					:order="order"
                    class="order-on-date"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import { defineComponent } from "vue";
import { getDateGroupCompletionStatus } from "@/lib/HelperFns";
import OrderInList from "./OrderInList.vue";

export default defineComponent({
    name: 'OrderDateGroup',
    components: {
        OrderInList,
    },
    props: {
        date: {
            type: String,
            required: true,
        },
        orders: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isExpanded: false,
        };
    },
    computed: {
        datesStatus() {
            return getDateGroupCompletionStatus(this.orders);
        },
        orderIcon() {
            switch (this.datesStatus.status) {
                case 'all-completed':
                    return 'check';
                case 'partially-completed':
                    return 'timer-sand';
                case 'none-completed':
                    return 'close';
                default:
                    return 'close';
            }
        },
        orderColor() {
            switch (this.datesStatus.status) {
                case 'all-completed':
                    return '#48c774';
                case 'partially-completed':
                    return '#646464';
                default:
                    return '#ff3860';
            }
        },
        completionText() {
            const { status, totalOrders, completedOrders } = this.datesStatus;

            switch (status) {
                case 'all-completed':
                    return `${completedOrders}/${totalOrders}`;
                case 'none-completed':
                    return totalOrders.toString();
                case 'partially-completed':
                    return `${completedOrders}/${totalOrders}`;
                default:
                    return '0';
            }
        },
    },
    methods: {
        expandOrdersOnDate() {
            this.isExpanded = !this.isExpanded;
        },
    },
	mounted() {
		const dateTime = DateTime.fromFormat(this.date, 'yyyy-LL-dd', { zone: 'local' });
		this.isExpanded = DateTime.now().diff(dateTime, 'days').days < 30;
	},
})
</script>

<style scoped>
.date-group {
    margin-bottom: 1rem;
    max-width: 50vw;
}

.date-header {
    cursor: pointer;
    padding: 0.75rem;
    background-color: #f5f5f5;
    border: 1px solid #c7d4f7;
    border-radius: 12px;
    display: flex;
    align-items: center;
    width: 100%;
}

.date-header:hover {
    background-color: #eeeeee;
}

.folder-icon {
    margin-right: 0.5rem;
    color: #3273dc;
}

.date-text {
    font-weight: 500;
    color: #363636;
    white-space: nowrap;
}

.completion-status {
    margin-left: 0.5rem;
    display: inline-flex;
    align-items: center;
}

.completion-icon {
    margin-right: 0.25rem;
}

.orders-container {
    margin-top: 0.5rem;
    margin-left: 1rem;
    border-left: 2px solid #c7d4f7;
    padding-left: 1rem;
}

.order-on-date{
    margin-bottom: .75rem;
    padding: 0.5rem;
    background-color: #fafafa;
    border-radius: 3px;
}
</style>
